<template>
  <section class="reset-password flex flex-center">
    <ba-card>
      <template slot="header">
        <span>Mot de passe oublié</span>
      </template>
      <template v-if="getToken">
        <form @submit.prevent="handleResetPassword">
          <p>Merci de saisir votre nouveau mot de passe</p>
          <ba-input type="password" label="Nouveau mot de passe" class="mandatory" v-model="newPassword"></ba-input>
          <ba-input type="password" label="Confirmation mot de passe" class="mandatory" v-model="confirmPassword"></ba-input>
          <div class="buttons-container flex flex-space">
            <router-link :to="{ name: 'Login' }" class="btn-action primary">Annuler</router-link>
            <ba-button class="primary">Valider</ba-button>
          </div>
        </form>
      </template>
      <template v-else>
        <p>La session a expiré. Veuillez recommencer.</p>
        <div class="buttons-container flex flex-end">
          <router-link :to="{ name: 'Login' }" class="btn-action primary">Retour</router-link>
        </div>
      </template>
    </ba-card>
  </section>
</template>

<script>
import { BaButton, BaCard, BaInput } from '@ab/basic-components';

export default {
  name: 'ResetPassword',
  components: {
    BaButton,
    BaCard,
    BaInput
  },
  mounted() {
    this.checkToken().then(token => this.getToken = token);
  },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      getToken: false,
    }
  },
  methods: {
    async checkToken() {
      console.log(this.$route.query.token);
      const response = await this.$store.dispatch('checkPwdChange', {
        token: this.$route.query.token,
      });
      return response.success;
    },
    async handleResetPassword() {
      if (this.newPassword && this.confirmPassword) {
        if ((!this.newPassword.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+=.;_{}<>|^£:"'])[A-Za-z\d@$!%*#?&+=.;_{}<>|^£:"']{8,}$/)) || (!this.confirmPassword.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+=.;_{}<>|^£:"'])[A-Za-z\d@$!%*#?&+=.;_{}<>|^£:"']{8,}$/))) {
          this.$store.dispatch('displaySnackbar', { text: "Votre mot de passe doit contenir au moins 8 caractères dont 1 lettre 1 chiffre et 1 caractère spécial", mode: '' });
          return;
        }
        if (this.newPassword == this.confirmPassword) {
          const data = await this.$store.dispatch('changePassword', {
            token: this.$route.query.token,
            password: this.newPassword.replaceAll('?', '‰‰'),
            passwordConfirm: this.confirmPassword.replaceAll('?', '‰‰'),
          });
          if (data && data.success) {
            this.$store.dispatch('displaySnackbar', { text: "Votre mot de passe a été réinitialisé", mode: '' });
            this.$router.push({ name: 'Login' });
          }
        } else {
          this.$store.dispatch('displaySnackbar', {
            text: "Les champs entrés ne sont pas identiques. Veuillez réessayer",
            mode: 'error'
          });
        }
      } else {
        this.$store.dispatch('displaySnackbar', {
          text: "Veuillez remplir les champs obligatoires",
          mode: 'error'
        });
      }
    }
  }
};
</script>

<style scoped>
.reset-password {
  height: 100%;
}
/* Card position */
.reset-password .ba-card {
  width: 376px;
}

/* Margin between components */
.reset-password form p {
  text-align: center;
  margin-bottom: 3rem;
} 
.reset-password .ba-input {
  margin-bottom: 2rem;
}
.reset-password .buttons-container {
  margin-top: 2.5rem;
}
</style>
<style>
/* Modal, override native ba-card component style */
#app .reset-password .ba-card main {
  font-size: 0.79rem;
  padding: 1.5rem 3.6rem;
}
</style>
